/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_CatInputs */

const en_svc_mcp_server_development_cat = /** @type {(inputs: Svc_Mcp_Server_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MCP`)
};

const ar_svc_mcp_server_development_cat = /** @type {(inputs: Svc_Mcp_Server_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MCP`)
};

const bn_svc_mcp_server_development_cat = /** @type {(inputs: Svc_Mcp_Server_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MCP`)
};

const de_svc_mcp_server_development_cat = /** @type {(inputs: Svc_Mcp_Server_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MCP`)
};

const es_svc_mcp_server_development_cat = /** @type {(inputs: Svc_Mcp_Server_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MCP`)
};

const fr_svc_mcp_server_development_cat = /** @type {(inputs: Svc_Mcp_Server_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MCP`)
};

const pt_svc_mcp_server_development_cat = /** @type {(inputs: Svc_Mcp_Server_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MCP`)
};

const zh_svc_mcp_server_development_cat = /** @type {(inputs: Svc_Mcp_Server_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MCP`)
};

const tr_svc_mcp_server_development_cat = /** @type {(inputs: Svc_Mcp_Server_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MCP`)
};

const ru_svc_mcp_server_development_cat = /** @type {(inputs: Svc_Mcp_Server_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MCP`)
};

const pl_svc_mcp_server_development_cat = /** @type {(inputs: Svc_Mcp_Server_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MCP`)
};

/**
* | output |
* | --- |
* | "#MCP" |
*
* @param {Svc_Mcp_Server_Development_CatInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_cat = /** @type {((inputs?: Svc_Mcp_Server_Development_CatInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_CatInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_cat(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_cat(inputs)
	if (locale === "de") return de_svc_mcp_server_development_cat(inputs)
	if (locale === "es") return es_svc_mcp_server_development_cat(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_cat(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_cat(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_cat(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_cat(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_cat(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_cat(inputs)
	return en_svc_mcp_server_development_cat(inputs)
});
export { svc_mcp_server_development_cat as "svc_mcp-server-development_cat" }